import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class Activate {

    constructor(private http: HttpClient) { }

    get(key: string): Observable<any> {
        let httpParams: HttpParams = new HttpParams().set('key', key);

        return this.http.get('api/activate', {
            params: httpParams,
            responseType: 'text'
        }).map((res: string) => res);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/activate/activate.service.ts